import { Component } from '@angular/core';
import { WorkflowBaseDroppedField } from '../base-dropped-field.component';

@Component({
  selector: 'app-workflow-droppable-email-field',
  templateUrl: './email.component.html',
  styleUrls: ['../../droppable-field.component.scss']
})
export class WorkflowDroppableEmailFieldComponent extends WorkflowBaseDroppedField {}
